import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { InvoiceOverdueBannerProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { DateConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { Banner, GridR, StyledButton, useCheckRelations } from "components/common";
import { Box, Grid } from "@mui/material";
import useInvoicePreview from "../usePreview";
import useSendToDebtCollectionDialog from "../forms/useSendToDebtCollectionDialog";
import { useDebtCollectionService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const InvoiceOverdueBanner: React.FC<InvoiceOverdueBannerProps> = (props) => {
  const debtCollectionService = useDebtCollectionService();
  const { invoice, reloadHandler } = props;
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const invoiceId = invoice.id;
  const getDebtCollectionForm = useSendToDebtCollectionDialog(props.reloadHandler);
  const { showPreviewDialog } = useInvoicePreview();
  const onShowInvoicePreview = async () => {
    showPreviewDialog(invoice, undefined, undefined, reloadHandler, undefined, true);
  };

  const onSendInvoiceClaimClicked = async () => {
    dispatch(displayDialog(getDebtCollectionForm(invoiceId)));
  };

  const { getIsReadonlyUser } = useCheckRelations();

  if (getIsReadonlyUser()) {
    return <></>;
  }

  return (
    <Banner
      title={LocalizationHelperInstance.getFormattedMessage(
        invoice.status === WintSuperkollAPIModel.InvoiceStatus.OverdueReminderSent
          ? TranslationKeys.Invoice.Reminded
          : TranslationKeys.Common.Overdue
      )}
      icon={IconDefinitionConstants.WBell}
      type={StyleEnums.DisplayType.Danger}
    >
      <GridR container direction="column" spacing={3}>
        <Grid item>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.OverdueText, "", {
            dueDate: LocalizationHelperInstance.getFormattedDate(invoice.dueDate, DateConstants.DateMonthLongConfig),
            reminderCount: `${invoice.pDFCount - 1}`,
          })}
        </Grid>
        <Grid item>
          <Box m={1} component="span">
            <StyledButton size="sm" displayType={StyleEnums.DisplayType.Danger} onClick={onShowInvoicePreview}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.SendReminder)}
            </StyledButton>
          </Box>
          {debtCollectionService.canAllowDebtCollection(invoice.reminderInvoicesCount) ? (
            <Box m={1} component="span">
              <StyledButton size="sm" displayType={StyleEnums.DisplayType.Danger} onClick={onSendInvoiceClaimClicked}>
                {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.SendInvoiceClaim)}
              </StyledButton>
            </Box>
          ) : (
            <></>
          )}
        </Grid>
      </GridR>
    </Banner>
  );
};

export default InvoiceOverdueBanner;
